import padAdmin from "./padAdmin";

export default [...padAdmin];
